export interface MenuItem {
  key: string;
  href?: string;
  children?: MenuItem[];
}

export const getActiveMenuKeys = (
  menus: MenuItem[],
  pathname: string
): string[] => {
  const keys: string[] = [];

  const traverse = (menuList: MenuItem[]) => {
    menuList.forEach((menu) => {
      if (menu.children) {
        menu.children.forEach((child) => {
          if (pathname.startsWith(child.href || "")) {
            keys.push(menu.key, child.key);
          }
        });
        // optional: check if parent itself has a href
        if (menu.href && pathname.startsWith(menu.href)) {
          keys.push(menu.key);
        }
      } else if (menu.href && pathname.startsWith(menu.href)) {
        keys.push(menu.key);
      }
    });
  };

  traverse(menus);

  return keys;
};
